import { SET_SALES } from "../actions/RequestActions";
import { SET_CUSTOMERS, SET_OPERATORS } from "../actions/userActions";

const initialState = {
  operators: null,
  customers: null,
  meta: {},
  sales: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPERATORS:
      return {
        ...state,
        operators: action.payload,
      };

    case SET_SALES:
      return {
        ...state,
        sales: action.payload,
      };

    case SET_CUSTOMERS:
      return {
        ...state,
        customers: action.payload.data,
        meta: action.payload.meta,
      };

    default:
      return state;
  }
};

export default userReducer;
